<template>
  <div>
    <el-dialog :visible.sync="loginsDV" width="400px" :before-close="closeLoginDV" class="login-DV"
      :close-on-click-modal="false">
      <div class="login-content">
        <div class="login" v-if="statusDV === 0">
          <div class="title">
            <div :class="['code', activeIndex === 1 ? 'active' : '']" @click="handleMethod(1)">
              扫码登录
            </div>
            <!-- <div
              :class="['password', activeIndex === 0 ? 'active' : '']"
              @click="handleMethod(0)"
            >
              邮箱登录
            </div> -->
          </div>
          <div class="emile-login" v-if="activeIndex === 0">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
              <el-form-item prop="loginName">
                <el-input v-model="loginForm.loginName" placeholder="邮箱"></el-input>
                <div class="loginName" v-if="verifyEmail" @click="handleStatus(1)">
                  立即注册
                </div>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="loginForm.password" placeholder="密码" type="password"></el-input>
              </el-form-item>
            </el-form>
            <div class="login-btn">
              <el-button @click="handleLogin">登录</el-button>
            </div>
            <div class="footer-tip">
              <span @click="handleStatus(1)">立即注册</span><span @click="handleStatus(2)">忘记密码</span>
            </div>
          </div>
          <div v-else>
            <div class="scan-code">
              <div id="qrCodeImg" ref="qrCodeImg"></div>
              <div class="qrcode" ref="qrCodeUrl" style="display: none"></div>
              <div class="code-tip">
                <img src="../../../assets/use-account/wx-icon.png" alt="" />请使用微信扫码登录
              </div>
              <div class="code-tip2">
                首次扫码<span class="red">关注快现形公众号</span>完成注册
              </div>
              <div class="lose-efficacy" v-if="loseCode">
                <div class="icon">!</div>
                <div>当前二维码已过期</div>
                <el-button class="login-btn btn" @click="loginQrCode(0)">刷新二维码</el-button>
              </div>
            </div>
          </div>
          <div class="user-protocol">
            登录成功即代表同意<span @click="handleProtocol(0)">《用户协议》</span><span @click="handleProtocol(1)">《隐私政策》</span>
          </div>
        </div>
        <div class="register" v-else-if="statusDV === 1">
          <div class="title">注册</div>
          <el-form ref="registerForm" :model="registerForm" class="register-form" :rules="registerRules">
            <el-form-item prop="email">
              <el-input v-model="registerForm.email" placeholder="邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="registerForm.password" placeholder="设置6～16位密码，区分大小写" type="password"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input v-model="registerForm.confirmPassword" placeholder="确认密码" type="password"></el-input>
            </el-form-item>
          </el-form>
          <div class="user-protocol">
            <el-checkbox v-model="registerCheck">我已知晓并同意</el-checkbox><span
              @click="handleProtocol(0)">《用户协议》</span><span @click="handleProtocol(1)">《隐私权政策》</span>
          </div>
          <div class="email-btn">
            <el-button @click="handleEmailCode(0)" v-if="!registerIsCount">
              发送邮箱验证
            </el-button>
            <el-button disabled v-else>{{ registerCount }}秒后重发</el-button>
          </div>
          <div class="footer-target" @click="handleStatus(0)">
            使用已有账户登录
          </div>
        </div>
        <div class="pasd" v-else-if="statusDV === 2">
          <div class="title">忘记密码</div>
          <el-form ref="retrieveForm" :model="retrieveForm" class="register-form" :rules="retrieveRules">
            <el-form-item prop="email">
              <el-input v-model="retrieveForm.email" placeholder="邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input v-model="retrieveForm.captcha" placeholder="图形验证码"></el-input>
              <div class="right-content">
                <img :src="imgCode" @click="tapCutImg" />
              </div>
            </el-form-item>
          </el-form>
          <div class="email-btn">
            <el-button @click="handleEmailCode(1)">发送邮箱验证码</el-button>
          </div>
          <div class="footer-target" @click="handleStatus(0)">返回</div>
        </div>
      </div>
    </el-dialog>
    <use-protocol :useProtocolDV="useProtocolDV" @closeUseProtocol="closeUseProtocol" />
    <privacy-protocol :privacyProtocolDV="privacyProtocolDV" @closePrivacyProtocol="closePrivacyProtocol" />
    <el-dialog :visible.sync="authDV" width="500px" :close-on-click-modal="false" :before-close="closeAuthDV"
      class="auth-DV">
      <div slot="title">微信扫码获取使用权限</div>
      <!-- <div class="qrcode" ref="qrCodeUrl2" v-if="authDV"></div> -->
      <div>
        <!--
        <img src="../../../assets/home/qrcode-3.jpeg" alt="" />
        -->
        <img src="../../../assets/home/managaer-qrcode-1.png" alt="" />
      </div>
      <span slot="footer" class="dialog-footer">
        <div>
          请使用同一微信扫码添加客户经理 添加后请勿删除，否则会影响产品使用
        </div>
      </span>
    </el-dialog>
    <guide v-if="showGuide" />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import {
  register,
  emailExist,
  login,
  resendVerifyEmail,
  sendVerifyEmail,
  loginQrCode,
  loginQrCodeStatus,
  ticketLogin,
  userInfo,
} from "@/api/user.js";
import { setItem, getItem } from "@/utils/storage.js";
import { isLogin, tokenInfo } from "@/api/home.js";
import useProtocol from "./use-protocol.vue";
import privacyProtocol from "./privacy-protocol.vue";
import { getQueryVariable, getToday } from "@/utils";
import guide from "@/components/guide.vue";
import { getCookie, setCookie, removeCookie } from "@/utils/cookie.js";
import { userConfig } from "@/api/home.js";
import { userInfo as getUserInfo } from "@/api/user";
import qs from "qs";
export default {
  name: "Login",
  components: {
    guide,
    privacyProtocol,
    useProtocol,
  },
  props: {
    loginDV: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let RegEmail = /^([A-z0-9]{6,18})(\w)+@[A-z0-9]+\.([A-z]{2,3})$/;
    let RedPsd = /^(?=.*[a-zA-Z\d])[!-~]{6,16}$/;
    let validateName = async (rule, val, callback) => {
      if (val === "") {
        this.verifyEmail = false;
        callback(new Error("请输入邮箱"));
      } else if (!RegEmail.test(val)) {
        this.verifyEmail = false;
        callback(new Error("请输入正确的邮箱"));
      } else if (RegEmail.test(val)) {
        let res = await emailExist({
          email: val,
        });
        if (!res.data) {
          this.$message.closeAll();
          callback(new Error("邮箱未注册，请点击"));
          this.verifyEmail = true;
        } else {
          this.verifyEmail = false;
          callback();
        }
      } else {
        callback();
        this.verifyEmail = false;
      }
    };
    let validateEmail = (rule, val, callback) => {
      if (val === "") {
        callback(new Error("请输入邮箱"));
      } else if (!RegEmail.test(val)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, val, callback) => {
      if (val === "") {
        callback(new Error("请输入密码"));
      } else if (!RedPsd.test(val)) {
        callback(new Error("密码格式不正确"));
      } else {
        callback();
      }
    };
    let validateConfirmPassword = (rule, val, callback) => {
      if (val === "") {
        callback(new Error("请输入密码"));
      } else if (this.registerForm.password !== val) {
        callback(new Error("两次密码输入不一致,请重新输入"));
      } else {
        callback();
      }
    };
    return {
      showGuide: false,
      activeIndex: 1,
      loginForm: {
        loginName: "",
        password: "",
      },
      loginRules: {
        loginName: [{ validator: validateName, trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      registerForm: {
        email: "",
        password: "",
        confirmPassword: "",
      },
      registerRules: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
      retrieveForm: {
        email: "",
        captcha: "",
      },
      retrieveRules: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        captcha: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
      },
      statusDV: 0, // 0：登录，1：注册，2：忘记密码
      imgCode: "/api/captcha/get?type=bindMobile",
      useProtocolDV: false,
      privacyProtocolDV: false,
      qrCodeUrl: "",
      loseCode: false,
      queryCodeId: null,
      registerCheck: true,
      registerCount: 59,
      registerIsCount: false,
      registerCountId: null,
      userInfo: {},
      verifyEmail: false,
      ticket: "",
      scene: "",
      timeId: null,
      loginsDV: false,
      authDV: false,
      qrCodeUrl2: "",
    };
  },
  computed: {},
  watch: {
    loginDV: {
      handler() {
        if (this.loginDV) {
          this.loseCode = false;
          this.$nextTick(() => {
            this.loginQrCode();
          });
        } else {
          this.loginsDV = JSON.parse(JSON.stringify(this.loginDV));
        }
      },
      immediate: true,
    },
  },
  async created() {
    if (this.$route.query.zbuc) {
      this.scene = this.$route.query.zbuc;
    } else {
      this.scene = getQueryVariable("zbuc") || getCookie("zbuc");
    }
    if (this.scene) {
      setCookie("zbuc", this.scene);
    }
    await this.getLoginInfo();
    /*
    this.havelogged()
    */
  },
  methods: {
    setUserInfo(data) {
      // console.log('setUserInfo', data)
      this.userInfo = data;
      setItem("userInfo", data);

      this.initVipMsg();
    },
    async getLoginInfo() {
      const userInfo = getItem("userInfo");
      if (userInfo) {
        /**
         * @description 2022/4/13 fuxinyi fix 有登录态时更新storage的会员过期时间 解决充值会员后db的过期时间与storage不同步问题
         * https://www.tapd.cn/49550092/bugtrace/bugs/view?bug_id=1149550092001000465
         */
        const {
          data: { memberExpireDate: memberExpireDateInDb },
        } = await getUserInfo();
        if (memberExpireDateInDb !== userInfo.memberExpireDate) {
          setItem(
            "userInfo",
            Object.assign(userInfo, { memberExpireDate: memberExpireDateInDb })
          );
        }
        this.userInfo = userInfo;
        this.$emit("setUserInfo");
        this.handleVip();
      } else {
        const { data, success } = await isLogin();
        if (data && success) {
          await this.getUserInfo();
          this.initVipMsg();
        }
      }
    },
    initVipMsg() {
      setItem("vipDayCurDate", "");
      setItem("vipExpireCurDate", "");
      userConfig({ configKey: "recharge_notice_flag", configValue: "false" });
      this.handleVip();
    },
    handleVip() {
      const today = getToday();
      const { memberExpireDay } = this.userInfo;

      // 会员状态, 0试用期, 1会员期, 2会员到期，3停用
      /* if (memberStatus === '2') {
        const vipExpireCurDate = getItem('vipExpireCurDate')
        if (vipExpireCurDate !== today) {
          this.$store.commit('setVipExpireMsg', true)
          // setItem('vipExpireCurDate', today)
        }
        return
      } */

      /**
       * @description 2022/4/21 过期也不弹 memberExpireDay<1为过期 不算0那天
       * https://www.tapd.cn/49550092/bugtrace/bugs/view/1149550092001000474
       */
      // 到期天数 到期7天内 每天弹一次
      if (memberExpireDay < 8 && memberExpireDay > 0) {
        const vipDayCurDate = getItem("vipDayCurDate");
        if (vipDayCurDate !== today) {
          this.$store.commit("setVipDayMsg", true);
          // setItem('vipDayCurDate', today)
        }
      }
    },
    async getUserInfo() {
      const { data, message, success } = await tokenInfo();
      if (success) {
        this.userInfo = data || { user: "loginSuccess" };
        this.setUserInfo(data);
        /*
        setItem('userInfo', data)
        */
        this.$emit("setUserInfo");
      } else {
        this.$message.error(message);
      }
    },
    async loginQrCode(type) {
      clearTimeout(this.queryCodeId);
      if (type == 0) this.loseCode = false;
      const requestParam = { scene: this.scene };
      const { zbuc } = qs.parse(window.location.search.slice(1));
      if (zbuc) {
        requestParam.zbuc = zbuc;
      }
      let res = await loginQrCode(requestParam);
      if (res.success) {
        this.qrCodeUrl = res.data.url;
        this.ticket = res.data.ticket;
        this.loginsDV = true;
        // this.creatQrCode()
        this.creatQrCode("qrCodeUrl", this.qrCodeUrl);
        this.loginQrCodeStatus();
        this.queryCodeId = setTimeout(() => {
          this.loseCode = true;
          clearInterval(this.timeId);
        }, 60000);
      }
    },
    havelogged() {
      isLogin().then((res) => {
        console.log(res.data);
      });
    },
    tokenInfoes() {
      var userName = getCookie("fst");
      tokenInfo(userName).then((res) => {
        if (res.code == 200) {
          console.log("登录");
          setItem("userInfo", res.data);
        }
      });
    },
    async tokenInfo() {
      const userName = getCookie("fst");
      await tokenInfo(userName);
    },
    loginQrCodeStatus() {
      this.timeId = setInterval(() => {
        loginQrCodeStatus({
          ticket: this.ticket,
        }).then((res) => {
          if (res.success) {
            if (res.data) {
              clearInterval(this.timeId);
              ticketLogin({
                ticket: this.ticket,
              }).then(async (res2) => {
                console.log("ticketLogin", res2);
                if (res2.success) {
                  if (getCookie("zbuc")) {
                    removeCookie("zbuc");
                  }
                  this.$store.commit("setIsFromFriend", false);
                  this.$message.closeAll();
                  this.$message({
                    type: "success",
                    message: "登录成功",
                    duration: 2000,
                    offset: 100,
                  });
                  /*
                  this.tokenInfoes()
                  */
                  await this.tokenInfo();
                  if (res2.data.newUser) {
                    this.showGuide = true;
                  }
                  userInfo().then((result) => {
                    console.log("userInfo", result);
                    res2.data.memberExpireDate = result.data.memberExpireDate;
                    clearTimeout(this.queryCodeId);

                    this.setUserInfo(result.data);

                    // setItem('userInfo', res2.data)
                    this.$emit("isLogin");
                    const { clientId, profileId, country } = qs.parse(
                      window.location.search.slice(1)
                    );
                    if (clientId === "kxx21010009") {
                      this.$eventBus.$emit("onSearch", { profileId, country });
                      return;
                    }
                    if (res2.data.newUser) {
                      setTimeout(() => {
                        // this.qrCodeUrl2 = res2.data.qyCustomerQrCodeUrl
                        this.authDV = true;
                        // this.creatQrCode('qrCodeUrl2', this.qrCodeUrl2)
                      }, 2000);
                    }
                  });
                } else {
                  this.$message.closeAll();
                  this.$message({
                    type: "error",
                    message: res2.message,
                    duration: 30000,
                    showClose: true,
                  });
                  this.$emit("closeLoginDV");
                }
              });
            }
          }
        });
      }, 3000);
    },
    creatQrCode(dom, val) {
      this.$nextTick(() => {
        this.$refs[dom].innerHTML = "";
        new QRCode(this.$refs[dom], {
          text: val, // 需要转换为二维码的内容
          width: 236,
          height: 236,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        // 在小米或者华为手机上生成的二维码是通过canvas展示的，img标签被隐藏,所以需要特殊处理一下，将
        // canvas标签隐藏，拿到生成的url放到img里面再展示出来
        let myCanvas = document.getElementsByTagName("canvas")[0];
        let img = this.convertCanvasToImage(myCanvas);
        let code = document.getElementById("qrCodeImg");
        code.innerHTML = "";
        code.appendChild(img);
      });
    },
    convertCanvasToImage(canvas) {
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      return image;
    },
    closeLoginDV() {
      clearInterval(this.timeId);
      clearTimeout(this.queryCodeId);
      this.$emit("closeLoginDV");
      this.loginForm = {
        loginName: "",
        password: "",
      };
      this.registerForm = {
        email: "",
        password: "",
        confirmPassword: "",
      };
      this.retrieveForm = {
        email: "",
        captcha: "",
      };
      setTimeout(() => {
        this.activeIndex = 1;
        this.statusDV = 0;
        this.loseCode = false;
      }, 500);
    },
    handleMethod(index) {
      this.verifyEmail = false;
      this.activeIndex = index;
      clearInterval(this.timeId);
      clearTimeout(this.queryCodeId);
      if (index === 1) {
        this.loseCode = false;
        this.loginQrCode();
      }
    },
    async handleLogin() {
      if (this.activeIndex === 0) {
        this.$refs["loginForm"].validate(async (valid) => {
          if (valid) {
            let res = await login(this.loginForm);
            if (res.success) {
              this.$message.closeAll();
              this.$message.success("登录成功");
              this.userInfo = res.data || { user: "loginSuccess" };
              this.setUserInfo(this.userInfo);
              /*
              setItem('userInfo', this.userInfo)
              */
              this.$emit("isLogin");
              if (res.data.newUser) {
                setTimeout(() => {
                  // this.qrCodeUrl2 = res.data.qyCustomerQrCodeUrl
                  this.authDV = true;
                  // this.creatQrCode('qrCodeUrl2', this.qrCodeUrl2)
                }, 2000);
              }
            } else {
              this.$emit("closeLoginDV");
            }
          } else {
            return false;
          }
        });
      }
    },
    handleStatus(index) {
      this.verifyEmail = false;
      this.statusDV = index;
      if (index === 1) {
        clearInterval(this.registerCountId);
        this.registerIsCount = false;
      }
    },
    async handleEmailCode(index) {
      this.$message.closeAll();
      if (index === 0) {
        if (!this.registerCheck) return this.$message.error("请先勾选协议内容");
      }
      if (index === 0) {
        this.$refs["registerForm"].validate(async (valid) => {
          if (valid) {
            this.registerCount = 59;
            this.registerIsCount = true;
            this.registerCountId = setInterval(() => {
              if (this.registerCount === 0) {
                clearInterval(this.registerCountId);
                this.registerIsCount = false;
              } else {
                this.registerCount--;
              }
            }, 1000);
            let res = await emailExist({
              email: this.registerForm.email,
            });
            if (!res.success) {
              return;
            }
            let res1 = await register(this.registerForm);
            if (res1.success) {
              this.closeLoginDV();
            } else {
              if (res1.errorCode == "user.email.unverified") {
                this.$message.closeAll();
                let res2 = await resendVerifyEmail(this.registerForm);
                if (res2.success) {
                  this.closeLoginDV();
                }
              }
            }
          } else {
            return false;
          }
        });
      } else {
        this.$refs["retrieveForm"].validate(async (valid) => {
          if (valid) {
            let res = await sendVerifyEmail(this.retrieveForm);
            if (res.success) {
              this.$message.success("发送邮件成功，请前往邮箱处理");
              this.closeLoginDV();
            } else {
              this.tapCutImg();
            }
          } else {
            return false;
          }
        });
      }
    },
    handleProtocol(index) {
      if (index === 0) {
        this.useProtocolDV = true;
      } else {
        this.privacyProtocolDV = true;
      }
    },
    closeUseProtocol() {
      this.useProtocolDV = false;
    },
    closePrivacyProtocol() {
      this.privacyProtocolDV = false;
    },
    tapCutImg() {
      this.imgCode = "/api/captcha/get?type=bindMobile" + +new Date();
    },
    closeAuthDV() {
      this.authDV = false;
    },
  },
};
</script>

<style scoped lang="scss">
.login-DV {
  ::v-deep.el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep.el-dialog__body {
    padding-top: 18px;
  }

  .login-content {
    position: relative;
    height: 395px;

    .login {
      padding: 0 20px;

      .title {
        display: flex;
        justify-content: center;
        font-size: 24px;
        border-bottom: 1px solid #eceff5;

        .password,
        .code {
          padding-bottom: 24px;
          cursor: pointer;
        }

        .active {
          // border-bottom: 2px solid #3c7cff;
          border-radius: 1px;
          font-weight: bold;
          color: #24232f;
        }
      }

      .emile-login {
        position: relative;

        .loginName {
          position: absolute;
          top: 40px;
          left: 115px;
          font-size: 12px;
          font-weight: 400;
          color: #3c7cff;
          cursor: pointer;
        }

        ::v-deep.login-form {
          margin: 36px 0 50px;

          .el-input__inner {
            border-top: 0;
            border-left: 0;
            border-right: 0;
            border-radius: 0;
            margin-bottom: 10px;
          }
        }

        .login-btn {
          margin-bottom: 20px;

          .el-button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 320px;
            height: 50px;
            background: linear-gradient(-64deg, #2f65ff, #4e84ff);
            border-radius: 25px;
            color: #fff;
          }
        }

        .footer-tip {
          display: flex;
          justify-content: space-between;

          span {
            font-size: 16px;
            font-weight: 400;
            color: #24232f;
            cursor: pointer;
          }
        }
      }

      .scan-code {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 28px;
        position: relative;

        .code-tip {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 8px;
          font-size: 16px;
          font-weight: 400;
          color: #a3aab7;

          img {
            width: 20px;
            height: 15px;
            margin-right: 4px;
          }
        }

        .code-tip2 {
          margin: 2px 0;
          font-size: 14px;
          color: #9197a5;

          .red {
            color: red;
            font-weight: bold;
          }
        }

        .lose-efficacy {
          position: absolute;
          top: -12px;
          left: 50%;
          transform: translate(-50%, 0);
          width: 238px;
          height: 250px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: rgba(255, 255, 255, 0.8);
          color: #181b23;
          font-weight: bold;
          font-size: 20px;

          .icon {
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 50%;
            color: #fff;
            box-shadow: 0px 1px 2px 0px #ffffff,
              0px 8px 8px 0px rgba(253, 185, 68, 0.21);
            background: #ffa200;
            opacity: 0.8;
            margin-bottom: 8px;
          }

          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
            height: 32px;
            color: #fff;
          }

          .login-btn {
            color: #015bff;
            font-weight: 400;
            border: 1px solid #4e84ff;
            background: linear-gradient(-64deg, #2f65ff, #4e84ff);
            color: #fff;
            margin-top: 18px;
          }
        }
      }

      .user-protocol {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        font-size: 14px;

        span {
          cursor: pointer;
          color: #1772f7;
        }
      }
    }

    .register,
    .pasd {
      position: relative;
      height: 100%;

      .title {
        position: absolute;
        top: -36px;
        left: 50%;
        transform: translate(-50%, 0);
        text-align: center;
        font-size: 24px;
        font-weight: 400;
        color: #24232f;
        z-index: 99;
      }

      ::v-deep.el-form {
        padding-top: 28px;

        .el-input__inner {
          border: 0;
          border-bottom: 1px solid #edeef3;
          margin-bottom: 10px;
        }
      }

      .user-protocol {
        font-size: 14px;
        margin-bottom: 20px;

        .el-checkbox {
          font-weight: 400;
          color: #24232f;
        }

        span {
          cursor: pointer;
          color: #3c7cff;
        }
      }

      .email-btn {
        display: flex;
        justify-content: center;

        .el-button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 320px;
          height: 50px;
          background: linear-gradient(-64deg, #2f65ff, #4e84ff);
          border-radius: 25px;
          color: #fff;
          font-weight: 400;
          font-size: 16px;
        }

        .disabled {
          cursor: not-allowed;
        }
      }

      .footer-target {
        position: absolute;
        bottom: 0;
        right: 0;
        font-weight: 400;
        color: #3c7cff;
        font-size: 16px;
        cursor: pointer;
      }

      .el-form-item__content {
        position: relative;
      }

      .right-content {
        position: absolute;
        right: 10px;
        top: 0;
        width: 80px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        color: #3c7cff;

        .down {
          color: #7a7a7a;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .pasd {
      .email-btn {
        margin-top: 68px;
      }
    }
  }
}

::v-deep.auth-DV {
  font-size: 14px;

  .el-dialog__header {
    padding-left: 0;
    padding-right: 0;

    >div {
      text-align: center;
      color: #595959;
      padding-bottom: 15px;
      border-bottom: 1px solid #ebebeb;
    }
  }

  .el-dialog__body {
    display: flex;
    justify-content: center;
  }

  img {
    height: 240px;
  }
}
</style>
